import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from '../components/Header';

export default function About() {
    var content = `Stuttgart-based software engineer.
My interests revolve around arts - mostly music, painting, and film.
Of course, I have a deep passion for software engineering itself, but the scope of my pursuits can’t be defined by that alone.
I created this website to share my artwork and to publish reviews, essays, and maybe even short stories down the road.`;
    return (
        <div class='about'>
            <Header />
            <div class='about-content'>
                <div class='about-content-text' style={{ whiteSpace: 'pre-wrap' }}>
                    { content }
                </div>
            </div>
        </div>
    );
}